import NotificationModal from '@anm/components/modals/NotificationModal';
import useNotifications, {
  NotificationElement
} from '@anm/hooks/useNotifications';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';

const Notification: FC<NotificationElement> = ({
  id,
  deleteNotification,
  ...rest
}) => {
  const onModalClose = useCallback(() => {
    deleteNotification(id);
  }, [deleteNotification, id]);

  return (
    <NotificationModal
      key={id}
      variant="aside"
      timeout={7000}
      {...{ onModalClose, ...rest }}
    />
  );
};

const Notifications: FC = () => {
  const updateMetaEntity = useSelector(
    templateSelectors.selectUpdateTemplateMeta
  );
  const { notifications } = useNotifications({
    errorTitle: 'Error',
    errorMessage: 'Something went wrong !',
    successTitle: 'Success',
    successMessage: 'Template has been successfully updated',
    ...updateMetaEntity
  });

  return (
    <>
      {notifications.map((n: NotificationElement) => (
        <Notification {...n} />
      ))}
    </>
  );
};

export default Notifications;
